// extracted by mini-css-extract-plugin
export default {"text":"HomeLocationTitleText_text__rJmFL"};